<template>
    <div class="templete">
        <div class="search_box clearfix StockSearch">
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.batch_no" placeholder="批次号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.ship_no" placeholder="船名" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.heap_no" placeholder="堆号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="根号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="树种" @visible-change="getSelectWarehouseList('breed_id')">
                <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <el-select class="search_select search_inputBox" v-model="params.length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.thickness" multiple collapse-tags placeholder="直径" @visible-change="getSelectWarehouseList('original_thickness')">
                <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-input class="search_input search_inputBox" v-model="params.cube" placeholder="码单立方" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.sales_price " placeholder="挂牌价" size="mini"></el-input> -->
            <!-- <div class="search_time search_inputBox">
                <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库时间"></el-date-picker>
            </div> -->
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注" size="mini"></el-input>
            <!-- <el-select class="search_select search_inputBox" v-model="params.status" placeholder="资源状态">
                <el-option v-for="list in statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
            </div>
        </div>
        <div class="tableBox selectStockTable">
            <tabletem :isSetCol="true" scene="processing.materials.wood" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="btnList clearfix">
            <div class="totalBox">
                <div class="total">选中根数：{{totalNumber}}根</div>
                <div class="total">选中方数：{{totalCube}}</div>
            </div>
            <div class="btnBox">
                <el-button  class="funcPublicBtn" @click="cancel">取消</el-button>
                <el-button  class="funcPublicBtn" @click="selectData">选中</el-button>
                <el-button  class="funcPublicBtn funcPublicBtnChecked" @click="selectAndOut">选中并退出</el-button>
            </div>
        </div>
        <!-- 宽度列表START -->
        <!-- <el-dialog :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog> -->
        <!-- 宽度列表END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="processing.materials.wood" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import tabletem from './table.vue'
    import pagination from './pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                isShowMore:false,
                dialogVisibleWidth:false,
                params:{
                    contract_no:"",
                    batch_no:"",
                    ship_no:"",
                    heap_no:"",
                    bale_no:"",
                    length:"",
                    thickness:"",
                    cube:"",
                    sales_price:"",
                    warehouse_id:"",
                    supplier_id:"",
                    remark:"",
                    processing_type:1,
                    per_page:50,
                    page:1
                },
                last_page:1,
                total:0,
                totalNumber:0,
                totalCube:0,
                selectRow:[],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[]
                },
                statusList:[],
                widthList:[],
                list:[],
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[
                    {colName:"合同号",colKey:"contract_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"根号",colKey:"bale_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"直径",colKey:"diameter",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"码单立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:130,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}
                ]
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            filterConfirm(){
                this.getList()
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params,1).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            cancel(){
                this.$emit("cancel")
                this.getList()
            },
            selectData(){
                this.$emit("selectData",this.selectRow)
            },
            selectAndOut(){
                this.$emit("selectAndOut",this.selectRow)
                this.getList()
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.params.processing_type=1;
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.$postColumnList("/erp/processing.materials.wood",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="sales_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.sales_width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
            },
            getRow(row){
                this.selectRow=row;
                this.totalNumber=this.selectRow.length;
                this.totalCube=0;
                this.selectRow.forEach(item=>{
                    this.totalCube+=Number(item.sales_cube);
                })
                this.totalCube=this.keepLimit(this.totalCube)
            },
            resetSelect(){
                this.reset()
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
<style scoped>
    .templete{padding:0;}
    .pageAssembly .pageSize{margin-top:3px;}
    .totalBox{float: left;}
    .totalBox .total{float: left;font-size: 12px;line-height: 33px;margin-right:15px;}
    .btnBox{float: right;}
    .pageBox{text-align: center;}
</style>